import React from 'react';
import { twMerge } from 'tailwind-merge';
import { ToggleButton } from '@repo/common';

const PostToggleRow = ({
  label,
  required = false,
  helperText,
  value = false,
  onChange,
  disabled = false,
  className,
}) => {
  return (
    <div className={twMerge('w-full flex flex-col gap-2', className)}>
      <div className='flex items-center gap-0.5'>
        <span className='typo-b12Strong tabletH:typo-b16 text-text-primary'>
          {label}
        </span>
        {required && <span className='typo-b16Strong text-text-accent'>*</span>}
      </div>

      <div
        className={twMerge(
          'w-full rounded-lg px-4 py-4 flex items-center gap-2 bg-surface-lightgray60',
          disabled && 'opacity-60 pointer-events-none',
        )}
      >
        <p
          className={twMerge(
            'flex-1 typo-b16',
            value ? 'text-text-primary' : 'text-text-secondary',
          )}
        >
          {helperText}
        </p>
        <ToggleButton
          content=''
          togglePosition='left'
          value={value}
          onChange={onChange}
          offBgColor='bg-grayscale-gray03'
          offBorderColor='border-grayscale-gray03'
          offCircleColor='bg-grayscale-gray00'
          onBgColor='bg-green-deep02'
          onBorderColor='border-green-deep02'
          onCircleColor='bg-grayscale-gray00'
        />
      </div>
    </div>
  );
};

export default PostToggleRow;
